/* labosch-patches-pre-mobile-v95.js — V95 consolidated. */

/* ==== labosch-v59-final.js ==== */
(function(){
  'use strict';
  function cleanSizeToken(value){
    return String(value||'').replace(/^\s*talla\s*/i,'').trim();
  }
  function normalizeSizeGuide(modal){
    if(!modal)return;
    modal.querySelectorAll('.lbx-size-guide-size,.lbx-v23-size-card__size').forEach(function(node){
      var cleaned=cleanSizeToken(node.textContent);
      if(cleaned && cleaned!==node.textContent.trim()) node.textContent=cleaned;
    });
    var result=modal.querySelector('.lbx-size-guide-result-size');
    if(result){
      var cleanedResult=cleanSizeToken(result.textContent);
      if(cleanedResult && cleanedResult!==result.textContent.trim()) result.textContent=cleanedResult;
    }
  }
  document.addEventListener('click',function(event){
    var opener=event.target.closest&&event.target.closest('[data-lbx-size-guide-open],[data-mg2-size-guide]');
    if(!opener)return;
    var root=opener.closest('[id^="lbx-product-"]')||document;
    window.setTimeout(function(){normalizeSizeGuide(root.querySelector('[data-lbx-size-guide-modal]'));},0);
    window.setTimeout(function(){normalizeSizeGuide(root.querySelector('[data-lbx-size-guide-modal]'));},80);
  },true);
  document.addEventListener('input',function(event){
    if(!event.target.matches||!event.target.matches('[data-lbx-height-input]'))return;
    var modal=event.target.closest('[data-lbx-size-guide-modal]');
    window.setTimeout(function(){normalizeSizeGuide(modal);},0);
  },true);
  document.addEventListener('change',function(event){
    if(!event.target.matches||!event.target.matches('[data-lbx-height-input]'))return;
    normalizeSizeGuide(event.target.closest('[data-lbx-size-guide-modal]'));
  },true);
})();


/* ==== labosch-v68-final.js ==== */
(function(){
  'use strict';

  function distanceKm(lat1, lon1, lat2, lon2){
    var R = 6371;
    var toRad = function(value){ return Number(value) * Math.PI / 180; };
    var dLat = toRad(lat2 - lat1);
    var dLon = toRad(lon2 - lon1);
    var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
      Math.sin(dLon / 2) * Math.sin(dLon / 2);
    return R * 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  }

  function lockMaps(root){
    (root || document).querySelectorAll('iframe[data-lbx-locked-map], .mg2-dealers__map').forEach(function(frame){
      frame.setAttribute('tabindex','-1');
      frame.style.pointerEvents = 'none';
      frame.style.filter = 'none';
      frame.style.webkitFilter = 'none';
    });
  }

  function bootStoreLocator(root){
    if(!root || root.dataset.lbxV68Ready === '1') return;
    root.dataset.lbxV68Ready = '1';
    var button = root.querySelector('[data-mg2-dealer-location]');
    var status = root.querySelector('[data-mg2-dealer-nearest]');
    var cards = Array.prototype.slice.call(root.querySelectorAll('[data-mg2-dealer-card]'));
    lockMaps(root);
    if(!button || !status || !cards.length) return;

    function showStatus(html){
      status.innerHTML = html;
      status.hidden = false;
    }

    button.addEventListener('click', function(){
      if(!navigator.geolocation){
        showStatus('Tu navegador no permite calcular la tienda más cercana. Puedes buscar por ciudad o dirección.');
        return;
      }

      button.classList.add('is-loading');
      button.setAttribute('aria-busy','true');
      var original = button.lastElementChild ? button.lastElementChild.textContent : '';
      if(button.lastElementChild) button.lastElementChild.textContent = 'Localizando…';

      navigator.geolocation.getCurrentPosition(function(position){
        var userLat = Number(position.coords.latitude);
        var userLon = Number(position.coords.longitude);
        var nearest = null;
        cards.forEach(function(card){
          var lat = Number(card.dataset.storeLat);
          var lon = Number(card.dataset.storeLon);
          if(!Number.isFinite(lat) || !Number.isFinite(lon)) return;
          var km = distanceKm(userLat,userLon,lat,lon);
          if(!nearest || km < nearest.km) nearest = { card: card, km: km };
        });

        cards.forEach(function(card){ card.classList.remove('is-nearest'); });
        if(nearest){
          nearest.card.classList.add('is-nearest');
          var name = nearest.card.dataset.storeName || 'LaBosch';
          showStatus('Tu tienda más cercana es <strong>' + name.replace(/[&<>"']/g,function(ch){return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#039;'}[ch];}) + '</strong> · aprox. ' + Math.max(1,Math.round(nearest.km)) + ' km');
          var select = nearest.card.querySelector('[data-mg2-dealer-select]');
          if(select) select.click();
          nearest.card.scrollIntoView({behavior:'smooth',block:'nearest'});
        }else{
          showStatus('No hemos podido calcular la tienda más cercana. Puedes buscar por ciudad o dirección.');
        }
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if(button.lastElementChild) button.lastElementChild.textContent = original || 'Usar mi ubicación';
        lockMaps(root);
      },function(){
        showStatus('Activa la ubicación del navegador para recomendarte la tienda LaBosch más cercana.');
        button.classList.remove('is-loading');
        button.removeAttribute('aria-busy');
        if(button.lastElementChild) button.lastElementChild.textContent = original || 'Usar mi ubicación';
      },{enableHighAccuracy:false,timeout:8000,maximumAge:300000});
    });
  }

  function init(){
    document.querySelectorAll('[data-mg2-dealers]').forEach(bootStoreLocator);
    lockMaps(document);
  }

  document.addEventListener('DOMContentLoaded',init);
  document.addEventListener('shopify:section:load',init);
  window.addEventListener('pageshow',init);
  init();
})();

